<form class="ir-modal th-modal">
  <div class="ir-modal--title">
    <div class="ir-line--right">
      <div class="ir-btn th-btn-modal" (click)="selfModal.close()"><i class="material-icons">close</i></div>
    </div>
    <div class="ir-line">
      <div class="ir-line-content">
        <span>{{ 'common.add' | translate }}:{{ 'menus.contact' | translate }}</span>
      </div>
    </div>
  </div>
  <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
    <div class="ir-content--modal th-content">
      <div *ngIf="contacts">
        <div class="ir-item-line th-section-dark" *ngFor="let contact of contacts">
          <div class="ir-item-cell s8 strong">
            <span
              >{{ contact.FirstName }}, {{ contact.LastName }}, {{ contact.LastName }}, {{ contact.Company }},
              {{ contact.JobFunction }}, {{ contact.Email }}, {{ contact.Phone }}</span
            >
          </div>
          <div class="ir-item-cell s2 right strong statut">
            <i class="material-icons clickable" (click)="selectItem(contact)" *ngIf="!contact.selected"> add_circle </i>
            <i class="material-icons success clickable" (click)="selectItem(contact)" *ngIf="contact.selected">
              check_circle
            </i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="ir-modal--footer ir-position--b th-modal--footer">
    <div class="ir-row">
      <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
        <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="selfModal.close()">
          <span>{{ 'common.cancel' | translate }}</span>
        </div>
      </div>
      <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
        <button class="ir-btn ir-btn--big ir-btn--block ir-txt--right" type="submit" (click)="apply()">
          <span>{{ 'common.save-changes' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</form>
